import React from 'react';
import { useSelector, useStore } from 'react-redux';
import { selectIsSessionValidated } from 'services/session/session.selectors';
import { requestInboxStatsIfNecessary } from './inbox.action';

/**
 * Triggers at every url change, if deemed necessary,
 * an update to the inbox stats.
 */
export function useUpdateInboxStats() {
  // https://reacttraining.com/react-router/web/api/Hooks/uselocation
  const reduxStore = useStore();
  const isUserLoggedIn = useSelector(selectIsSessionValidated);

  React.useEffect(() => {
    if (!isUserLoggedIn) {
      return;
    }

    reduxStore.dispatch<any>(requestInboxStatsIfNecessary());
  }, [isUserLoggedIn, reduxStore]);
}
